module.exports = __webpack_public_path__ + "img/loading_andes.2c49d852.gif";